<template lang="html">
  <div class="Form">
    <div class="Form__wrapper">
      <h1 class="title-3">Payment information</h1>
      <p class="text-xlg text-semi">Payment methods are now managed through Stripe.</p>
      <p>You will be redirected to the subscription page.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PaymentInformation",
  mounted() {
    this.$router.push({ name: 'subscription' })
  },
}
</script>
